if (!customElements.get('deeplay-top-picks')) {
  customElements.define('deeplay-top-picks', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.signal = this.controller.signal;
      this.track = this.querySelector('[data-tp-track]');
      this.cards = Array.from(this.querySelectorAll('[data-tp-card]'));
      this.previous = this.querySelector('[data-tp-previous]');
      this.next = this.querySelector('[data-tp-next]');
      this.page = 0;

      if (!this.track || !this.cards.length) return;

      this.previous?.addEventListener('click', () => this.changePage(-1), { signal: this.signal });
      this.next?.addEventListener('click', () => this.changePage(1), { signal: this.signal });
      this.addEventListener('click', (event) => this.handleProviderClick(event), { signal: this.signal });
      this.addEventListener('keydown', (event) => this.handleProviderKeydown(event), { signal: this.signal });

      let touchStart = 0;
      this.track.addEventListener('touchstart', (event) => {
        touchStart = event.touches[0].clientX;
      }, { passive: true, signal: this.signal });
      this.track.addEventListener('touchend', (event) => {
        const distance = touchStart - event.changedTouches[0].clientX;
        if (Math.abs(distance) >= 45) this.changePage(distance > 0 ? 1 : -1);
      }, { passive: true, signal: this.signal });

      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => this.update(), 120);
      }, { signal: this.signal });

      requestAnimationFrame(() => this.update());
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    cssNumber(name, fallback) {
      const value = Number.parseInt(getComputedStyle(this).getPropertyValue(name), 10);
      return Number.isFinite(value) ? Math.max(1, value) : fallback;
    }

    columns() {
      if (matchMedia('(max-width: 749px)').matches) return 1;
      if (matchMedia('(max-width: 989px)').matches) return this.cssNumber('--tp-columns-tablet', 3);
      return this.cssNumber('--tp-columns-desktop', 5);
    }

    rows() {
      if (matchMedia('(max-width: 749px)').matches) return this.cssNumber('--tp-rows-mobile', 2);
      if (matchMedia('(max-width: 989px)').matches) return this.cssNumber('--tp-rows-tablet', 2);
      return this.cssNumber('--tp-rows-desktop', 2);
    }

    pageSize() {
      return this.columns() * this.rows();
    }

    pageCount() {
      return Math.max(1, Math.ceil(this.cards.length / this.pageSize()));
    }

    layout() {
      const columns = this.columns();
      const pageSize = this.pageSize();

      this.cards.forEach((card, index) => {
        const page = Math.floor(index / pageSize);
        const indexOnPage = index % pageSize;
        card.style.gridColumn = String((page * columns) + (indexOnPage % columns) + 1);
        card.style.gridRow = String(Math.floor(indexOnPage / columns) + 1);
      });
    }

    update() {
      this.layout();
      this.page = Math.max(0, Math.min(this.page, this.pageCount() - 1));
      const target = this.cards[this.page * this.pageSize()];
      this.track.style.transform = `translateX(${-(target?.offsetLeft || 0)}px)`;
      if (this.previous) this.previous.disabled = this.page === 0 || this.pageCount() === 1;
      if (this.next) this.next.disabled = this.page === this.pageCount() - 1 || this.pageCount() === 1;
    }

    changePage(direction) {
      const nextPage = Math.max(0, Math.min(this.page + direction, this.pageCount() - 1));
      if (nextPage === this.page) return;
      this.page = nextPage;
      this.update();
    }

    selectProvider(provider) {
      const payment = provider.closest('[data-tp-instalments]');
      if (!payment) return;

      const name = provider.dataset.tpProvider;
      payment.querySelectorAll('[data-tp-provider]').forEach((item) => {
        const selected = item === provider;
        item.setAttribute('aria-checked', String(selected));
        item.tabIndex = selected ? 0 : -1;
      });
      payment.querySelectorAll('[data-tp-payment-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.tpPaymentPanel !== name;
      });
    }

    handleProviderClick(event) {
      const provider = event.target.closest('[data-tp-provider]');
      if (provider && this.contains(provider)) this.selectProvider(provider);
    }

    handleProviderKeydown(event) {
      const provider = event.target.closest('[data-tp-provider]');
      if (!provider || !this.contains(provider)) return;

      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.selectProvider(provider);
        return;
      }

      if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
      const payment = provider.closest('[data-tp-instalments]');
      const providers = Array.from(payment?.querySelectorAll('[data-tp-provider]') || []);
      if (!providers.length) return;

      event.preventDefault();
      let index = providers.indexOf(provider);
      if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = providers.length - 1;
      else index = (index + (['ArrowLeft', 'ArrowUp'].includes(event.key) ? -1 : 1) + providers.length) % providers.length;
      this.selectProvider(providers[index]);
      providers[index].focus();
    }
  });
}